var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnalysts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "80px",
    viewBox: "0 0 64 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Analysts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Analysts",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_Blue_wGold",
    transform: "translate(0.142326, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#B7AC82",
    cx: 31.744186,
    cy: 32.5,
    rx: 31.744186,
    ry: 32.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#1A4480",
    cx: 31.744186,
    cy: 32.5,
    rx: 28.8139535,
    ry: 29.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.398140, 9.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.39534884,
    y: 37,
    width: 3.90697674,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 10.255814,
    y: 33,
    width: 3.90697674,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 15.9468984,
    y: 29,
    width: 3.90697674,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 21.8073636,
    y: 25,
    width: 3.90697674,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 27.6678287,
    y: 21,
    width: 3.90697674,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 33.5282938,
    y: 17,
    width: 3.90697674,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.575863953,18.9315951 C0.189073256,21.0035951 1.4622593,23.0165951 3.41955698,23.4265951 C5.37578023,23.8365951 7.27554767,22.4875951 7.66233837,20.4155951 C7.79927791,19.6795951 7.71928256,18.9565951 7.48300814,18.3055951 L13.680157,11.8645951 C13.8893756,11.9545951 14.1092407,12.0285951 14.3390686,12.0775951 C15.1360919,12.2445951 15.9167058,12.1075951 16.5962267,11.7625951 L20.2058826,15.0735951 C20.1665198,15.2055951 20.1176826,15.3305951 20.0917988,15.4695951 C19.7051058,17.5435951 20.9781942,19.5545951 22.9350035,19.9645951 C24.8912267,20.3745951 26.7908965,19.0275951 27.1776872,16.9535951 C27.3029058,16.2835951 27.2394174,15.6245951 27.0495384,15.0185951 L34.2335895,8.2295951 C34.4881291,8.3535951 34.7567337,8.4585951 35.0441895,8.5185951 C37.0021709,8.9285951 38.9013523,7.5805951 39.2880453,5.5065951 C39.6754221,3.4335951 38.4034081,1.4205951 36.4455244,1.0115951 C34.4887151,0.6015951 32.5889477,1.9495951 32.202157,4.0225951 C32.077036,4.6935951 32.1404267,5.3515951 32.3297198,5.9565951 L25.1462547,12.7475951 C24.8906407,12.6225951 24.6236965,12.5185951 24.3357523,12.4585951 C23.5392174,12.2905951 22.7581151,12.4275951 22.0785942,12.7745951 L18.4695244,9.4615951 C18.5088872,9.3295951 18.5577244,9.2045951 18.5835105,9.0655951 C18.9703012,6.9925951 17.6971151,4.9795951 15.7398174,4.5705951 C13.7841802,4.1605951 11.8832407,5.5085951 11.49645,7.5825951 C11.3595105,8.3165951 11.4400919,9.0405951 11.6763663,9.6915951 L5.47980349,16.1325951 C5.26999884,16.0425951 5.05071977,15.9675951 4.82089186,15.9195951 C2.86349651,15.5095951 0.962556977,16.8575951 0.575863953,18.9315951 Z",
    id: "Fill-59"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M5.249,75.516 L7.209,75.516 L6.985,74.676 C6.733,73.766 6.495,72.688 6.243,71.736 L6.187,71.736 C5.977,72.702 5.725,73.766 5.473,74.676 L5.249,75.516 Z M8.189,79.296 L7.629,77.126 L4.829,77.126 L4.269,79.296 L2.169,79.296 L5.039,70.168 L7.503,70.168 L10.373,79.296 L8.189,79.296 Z M11.325,79.296 L11.325,70.168 L13.439,70.168 L15.819,74.704 L16.729,76.72 L16.785,76.72 C16.687,75.754 16.519,74.466 16.519,73.388 L16.519,70.168 L18.479,70.168 L18.479,79.296 L16.365,79.296 L13.985,74.746 L13.089,72.758 L13.033,72.758 C13.131,73.766 13.299,74.984 13.299,76.062 L13.299,79.296 L11.325,79.296 Z M22.539,75.516 L24.499,75.516 L24.275,74.676 C24.023,73.766 23.785,72.688 23.533,71.736 L23.477,71.736 C23.267,72.702 23.015,73.766 22.763,74.676 L22.539,75.516 Z M25.479,79.296 L24.919,77.126 L22.119,77.126 L21.559,79.296 L19.459,79.296 L22.329,70.168 L24.793,70.168 L27.663,79.296 L25.479,79.296 Z M28.615,79.296 L28.615,70.168 L30.687,70.168 L30.687,77.56 L34.285,77.56 L34.285,79.296 L28.615,79.296 Z M36.203,79.296 L36.203,76.048 L33.459,70.168 L35.657,70.168 L36.483,72.268 C36.721,72.954 36.959,73.584 37.225,74.284 L37.281,74.284 C37.533,73.584 37.799,72.954 38.051,72.268 L38.863,70.168 L41.019,70.168 L38.261,76.048 L38.261,79.296 L36.203,79.296 Z M41.117,78.148 L42.307,76.734 C42.951,77.294 43.791,77.686 44.547,77.686 C45.401,77.686 45.821,77.35 45.821,76.804 C45.821,76.23 45.303,76.048 44.505,75.712 L43.329,75.208 C42.377,74.83 41.481,74.046 41.481,72.716 C41.481,71.204 42.839,70 44.729,70 C45.779,70 46.885,70.42 47.669,71.204 L46.633,72.506 C46.031,72.044 45.457,71.778 44.729,71.778 C44.029,71.778 43.567,72.086 43.567,72.604 C43.567,73.164 44.169,73.36 44.967,73.682 L46.129,74.158 C47.235,74.606 47.935,75.348 47.935,76.636 C47.935,78.148 46.675,79.464 44.505,79.464 C43.315,79.464 42.055,79.016 41.117,78.148 Z M50.973,79.296 L50.973,71.904 L48.453,71.904 L48.453,70.168 L55.537,70.168 L55.537,71.904 L53.031,71.904 L53.031,79.296 L50.973,79.296 Z M56.013,78.148 L57.203,76.734 C57.847,77.294 58.687,77.686 59.443,77.686 C60.297,77.686 60.717,77.35 60.717,76.804 C60.717,76.23 60.199,76.048 59.401,75.712 L58.225,75.208 C57.273,74.83 56.377,74.046 56.377,72.716 C56.377,71.204 57.735,70 59.625,70 C60.675,70 61.781,70.42 62.565,71.204 L61.529,72.506 C60.927,72.044 60.353,71.778 59.625,71.778 C58.925,71.778 58.463,72.086 58.463,72.604 C58.463,73.164 59.065,73.36 59.863,73.682 L61.025,74.158 C62.131,74.606 62.831,75.348 62.831,76.636 C62.831,78.148 61.571,79.464 59.401,79.464 C58.211,79.464 56.951,79.016 56.013,78.148 Z",
    id: "ANALYSTS",
    fill: "#1A4480"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalysts);
export default __webpack_public_path__ + "static/media/Icon_Analysts.a87a2ccb54aff3b60eea6768ef770f18.svg";
export { ForwardRef as ReactComponent };